export interface RequestStockPhraseDto {
  types: EnumStockPhraseType[] | null;
  customerAccountNumber: string | null;
  vendorAccountNumber: string | null;
}
export enum EnumStockPhraseType {
  All = 1,
  Order = 2,
  OrderDescription = 3,
  OrderFactoryNotes = 4,
}
